module.exports = function (e) {
  var n = {};

  function t(r) {
    if (n[r]) return n[r].exports;
    var o = n[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
  }

  return t.m = e, t.c = n, t.d = function (e, n, r) {
    t.o(e, n) || Object.defineProperty(e, n, {
      enumerable: !0,
      get: r
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, n) {
    if (1 & n && (e = t(e)), 8 & n) return e;
    if (4 & n && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (t.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & n && "string" != typeof e) for (var o in e) {
      t.d(r, o, function (n) {
        return e[n];
      }.bind(null, o));
    }
    return r;
  }, t.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(n, "a", n), n;
  }, t.o = function (e, n) {
    return Object.prototype.hasOwnProperty.call(e, n);
  }, t.p = "/dist/", t(t.s = 38);
}([function (e, n, t) {
  "use strict";

  e.exports = t(4);
}, function (e, n, t) {
  e.exports = t(6)();
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    var n = [];
    return n.toString = function () {
      return this.map(function (n) {
        var t = function (e, n) {
          var t = e[1] || "",
              r = e[3];
          if (!r) return t;

          if (n && "function" == typeof btoa) {
            var o = (i = r, l = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(l), "/*# ".concat(c, " */")),
                a = r.sources.map(function (e) {
              return "/*# sourceURL=".concat(r.sourceRoot).concat(e, " */");
            });
            return [t].concat(a).concat([o]).join("\n");
          }

          var i, l, c;
          return [t].join("\n");
        }(n, e);

        return n[2] ? "@media ".concat(n[2], "{").concat(t, "}") : t;
      }).join("");
    }, n.i = function (e, t) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var r = {}, o = 0; o < this.length; o++) {
        var a = this[o][0];
        null != a && (r[a] = !0);
      }

      for (var i = 0; i < e.length; i++) {
        var l = e[i];
        null != l[0] && r[l[0]] || (t && !l[2] ? l[2] = t : t && (l[2] = "(".concat(l[2], ") and (").concat(t, ")")), n.push(l));
      }
    }, n;
  };
}, function (e, n, t) {
  "use strict";

  var r,
      o = {},
      a = function a() {
    return void 0 === r && (r = Boolean(window && document && document.all && !window.atob)), r;
  },
      i = function () {
    var e = {};
    return function (n) {
      if (void 0 === e[n]) {
        var t = document.querySelector(n);
        if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
          t = t.contentDocument.head;
        } catch (e) {
          t = null;
        }
        e[n] = t;
      }

      return e[n];
    };
  }();

  function l(e, n) {
    for (var t = [], r = {}, o = 0; o < e.length; o++) {
      var a = e[o],
          i = n.base ? a[0] + n.base : a[0],
          l = {
        css: a[1],
        media: a[2],
        sourceMap: a[3]
      };
      r[i] ? r[i].parts.push(l) : t.push(r[i] = {
        id: i,
        parts: [l]
      });
    }

    return t;
  }

  function c(e, n) {
    for (var t = 0; t < e.length; t++) {
      var r = e[t],
          a = o[r.id],
          i = 0;

      if (a) {
        for (a.refs++; i < a.parts.length; i++) {
          a.parts[i](r.parts[i]);
        }

        for (; i < r.parts.length; i++) {
          a.parts.push(g(r.parts[i], n));
        }
      } else {
        for (var l = []; i < r.parts.length; i++) {
          l.push(g(r.parts[i], n));
        }

        o[r.id] = {
          id: r.id,
          refs: 1,
          parts: l
        };
      }
    }
  }

  function u(e) {
    var n = document.createElement("style");

    if (void 0 === e.attributes.nonce) {
      var r = t.nc;
      r && (e.attributes.nonce = r);
    }

    if (Object.keys(e.attributes).forEach(function (t) {
      n.setAttribute(t, e.attributes[t]);
    }), "function" == typeof e.insert) e.insert(n);else {
      var o = i(e.insert || "head");
      if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
      o.appendChild(n);
    }
    return n;
  }

  var s,
      f = (s = [], function (e, n) {
    return s[e] = n, s.filter(Boolean).join("\n");
  });

  function p(e, n, t, r) {
    var o = t ? "" : r.css;
    if (e.styleSheet) e.styleSheet.cssText = f(n, o);else {
      var a = document.createTextNode(o),
          i = e.childNodes;
      i[n] && e.removeChild(i[n]), i.length ? e.insertBefore(a, i[n]) : e.appendChild(a);
    }
  }

  var d = null,
      m = 0;

  function g(e, n) {
    var t, r, o;

    if (n.singleton) {
      var a = m++;
      t = d || (d = u(n)), r = p.bind(null, t, a, !1), o = p.bind(null, t, a, !0);
    } else t = u(n), r = function (e, n, t) {
      var r = t.css,
          o = t.media,
          a = t.sourceMap;
      if (o && e.setAttribute("media", o), a && btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(r));
      }
    }.bind(null, t, n), o = function o() {
      !function (e) {
        if (null === e.parentNode) return !1;
        e.parentNode.removeChild(e);
      }(t);
    };

    return r(e), function (n) {
      if (n) {
        if (n.css === e.css && n.media === e.media && n.sourceMap === e.sourceMap) return;
        r(e = n);
      } else o();
    };
  }

  e.exports = function (e, n) {
    (n = n || {}).attributes = "object" == typeof n.attributes ? n.attributes : {}, n.singleton || "boolean" == typeof n.singleton || (n.singleton = a());
    var t = l(e, n);
    return c(t, n), function (e) {
      for (var r = [], a = 0; a < t.length; a++) {
        var i = t[a],
            u = o[i.id];
        u && (u.refs--, r.push(u));
      }

      e && c(l(e, n), n);

      for (var s = 0; s < r.length; s++) {
        var f = r[s];

        if (0 === f.refs) {
          for (var p = 0; p < f.parts.length; p++) {
            f.parts[p]();
          }

          delete o[f.id];
        }
      }
    };
  };
}, function (e, n, t) {
  "use strict";
  /** @license React v16.8.6
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var r = t(5),
      o = "function" == typeof Symbol && Symbol.for,
      a = o ? Symbol.for("react.element") : 60103,
      i = o ? Symbol.for("react.portal") : 60106,
      l = o ? Symbol.for("react.fragment") : 60107,
      c = o ? Symbol.for("react.strict_mode") : 60108,
      u = o ? Symbol.for("react.profiler") : 60114,
      s = o ? Symbol.for("react.provider") : 60109,
      f = o ? Symbol.for("react.context") : 60110,
      p = o ? Symbol.for("react.concurrent_mode") : 60111,
      d = o ? Symbol.for("react.forward_ref") : 60112,
      m = o ? Symbol.for("react.suspense") : 60113,
      g = o ? Symbol.for("react.memo") : 60115,
      h = o ? Symbol.for("react.lazy") : 60116,
      y = "function" == typeof Symbol && Symbol.iterator;

  function b(e) {
    for (var n = arguments.length - 1, t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 0; r < n; r++) {
      t += "&args[]=" + encodeURIComponent(arguments[r + 1]);
    }

    !function (e, n, t, r, o, a, i, l) {
      if (!e) {
        if (e = void 0, void 0 === n) e = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [t, r, o, a, i, l],
              u = 0;
          (e = Error(n.replace(/%s/g, function () {
            return c[u++];
          }))).name = "Invariant Violation";
        }
        throw e.framesToPop = 1, e;
      }
    }(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", t);
  }

  var v = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  },
      x = {};

  function w(e, n, t) {
    this.props = e, this.context = n, this.refs = x, this.updater = t || v;
  }

  function k() {}

  function S(e, n, t) {
    this.props = e, this.context = n, this.refs = x, this.updater = t || v;
  }

  w.prototype.isReactComponent = {}, w.prototype.setState = function (e, n) {
    "object" != typeof e && "function" != typeof e && null != e && b("85"), this.updater.enqueueSetState(this, e, n, "setState");
  }, w.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  }, k.prototype = w.prototype;
  var E = S.prototype = new k();
  E.constructor = S, r(E, w.prototype), E.isPureReactComponent = !0;
  var _ = {
    current: null
  },
      C = {
    current: null
  },
      T = Object.prototype.hasOwnProperty,
      O = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function j(e, n, t) {
    var r = void 0,
        o = {},
        i = null,
        l = null;
    if (null != n) for (r in void 0 !== n.ref && (l = n.ref), void 0 !== n.key && (i = "" + n.key), n) {
      T.call(n, r) && !O.hasOwnProperty(r) && (o[r] = n[r]);
    }
    var c = arguments.length - 2;
    if (1 === c) o.children = t;else if (1 < c) {
      for (var u = Array(c), s = 0; s < c; s++) {
        u[s] = arguments[s + 2];
      }

      o.children = u;
    }
    if (e && e.defaultProps) for (r in c = e.defaultProps) {
      void 0 === o[r] && (o[r] = c[r]);
    }
    return {
      $$typeof: a,
      type: e,
      key: i,
      ref: l,
      props: o,
      _owner: C.current
    };
  }

  function P(e) {
    return "object" == typeof e && null !== e && e.$$typeof === a;
  }

  var M = /\/+/g,
      N = [];

  function R(e, n, t, r) {
    if (N.length) {
      var o = N.pop();
      return o.result = e, o.keyPrefix = n, o.func = t, o.context = r, o.count = 0, o;
    }

    return {
      result: e,
      keyPrefix: n,
      func: t,
      context: r,
      count: 0
    };
  }

  function I(e) {
    e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > N.length && N.push(e);
  }

  function $(e, n, t) {
    return null == e ? 0 : function e(n, t, r, o) {
      var l = typeof n;
      "undefined" !== l && "boolean" !== l || (n = null);
      var c = !1;
      if (null === n) c = !0;else switch (l) {
        case "string":
        case "number":
          c = !0;
          break;

        case "object":
          switch (n.$$typeof) {
            case a:
            case i:
              c = !0;
          }

      }
      if (c) return r(o, n, "" === t ? "." + B(n, 0) : t), 1;
      if (c = 0, t = "" === t ? "." : t + ":", Array.isArray(n)) for (var u = 0; u < n.length; u++) {
        var s = t + B(l = n[u], u);
        c += e(l, s, r, o);
      } else if (s = null === n || "object" != typeof n ? null : "function" == typeof (s = y && n[y] || n["@@iterator"]) ? s : null, "function" == typeof s) for (n = s.call(n), u = 0; !(l = n.next()).done;) {
        c += e(l = l.value, s = t + B(l, u++), r, o);
      } else "object" === l && b("31", "[object Object]" == (r = "" + n) ? "object with keys {" + Object.keys(n).join(", ") + "}" : r, "");
      return c;
    }(e, "", n, t);
  }

  function B(e, n) {
    return "object" == typeof e && null !== e && null != e.key ? function (e) {
      var n = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + ("" + e).replace(/[=:]/g, function (e) {
        return n[e];
      });
    }(e.key) : n.toString(36);
  }

  function F(e, n) {
    e.func.call(e.context, n, e.count++);
  }

  function U(e, n, t) {
    var r = e.result,
        o = e.keyPrefix;
    e = e.func.call(e.context, n, e.count++), Array.isArray(e) ? z(e, r, t, function (e) {
      return e;
    }) : null != e && (P(e) && (e = function (e, n) {
      return {
        $$typeof: a,
        type: e.type,
        key: n,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
      };
    }(e, o + (!e.key || n && n.key === e.key ? "" : ("" + e.key).replace(M, "$&/") + "/") + t)), r.push(e));
  }

  function z(e, n, t, r, o) {
    var a = "";
    null != t && (a = ("" + t).replace(M, "$&/") + "/"), $(e, U, n = R(n, a, r, o)), I(n);
  }

  function A() {
    var e = _.current;
    return null === e && b("321"), e;
  }

  var L = {
    Children: {
      map: function map(e, n, t) {
        if (null == e) return e;
        var r = [];
        return z(e, r, null, n, t), r;
      },
      forEach: function forEach(e, n, t) {
        if (null == e) return e;
        $(e, F, n = R(null, null, n, t)), I(n);
      },
      count: function count(e) {
        return $(e, function () {
          return null;
        }, null);
      },
      toArray: function toArray(e) {
        var n = [];
        return z(e, n, null, function (e) {
          return e;
        }), n;
      },
      only: function only(e) {
        return P(e) || b("143"), e;
      }
    },
    createRef: function createRef() {
      return {
        current: null
      };
    },
    Component: w,
    PureComponent: S,
    createContext: function createContext(e, n) {
      return void 0 === n && (n = null), (e = {
        $$typeof: f,
        _calculateChangedBits: n,
        _currentValue: e,
        _currentValue2: e,
        _threadCount: 0,
        Provider: null,
        Consumer: null
      }).Provider = {
        $$typeof: s,
        _context: e
      }, e.Consumer = e;
    },
    forwardRef: function forwardRef(e) {
      return {
        $$typeof: d,
        render: e
      };
    },
    lazy: function lazy(e) {
      return {
        $$typeof: h,
        _ctor: e,
        _status: -1,
        _result: null
      };
    },
    memo: function memo(e, n) {
      return {
        $$typeof: g,
        type: e,
        compare: void 0 === n ? null : n
      };
    },
    useCallback: function useCallback(e, n) {
      return A().useCallback(e, n);
    },
    useContext: function useContext(e, n) {
      return A().useContext(e, n);
    },
    useEffect: function useEffect(e, n) {
      return A().useEffect(e, n);
    },
    useImperativeHandle: function useImperativeHandle(e, n, t) {
      return A().useImperativeHandle(e, n, t);
    },
    useDebugValue: function useDebugValue() {},
    useLayoutEffect: function useLayoutEffect(e, n) {
      return A().useLayoutEffect(e, n);
    },
    useMemo: function useMemo(e, n) {
      return A().useMemo(e, n);
    },
    useReducer: function useReducer(e, n, t) {
      return A().useReducer(e, n, t);
    },
    useRef: function useRef(e) {
      return A().useRef(e);
    },
    useState: function useState(e) {
      return A().useState(e);
    },
    Fragment: l,
    StrictMode: c,
    Suspense: m,
    createElement: j,
    cloneElement: function cloneElement(e, n, t) {
      null == e && b("267", e);
      var o = void 0,
          i = r({}, e.props),
          l = e.key,
          c = e.ref,
          u = e._owner;

      if (null != n) {
        void 0 !== n.ref && (c = n.ref, u = C.current), void 0 !== n.key && (l = "" + n.key);
        var s = void 0;

        for (o in e.type && e.type.defaultProps && (s = e.type.defaultProps), n) {
          T.call(n, o) && !O.hasOwnProperty(o) && (i[o] = void 0 === n[o] && void 0 !== s ? s[o] : n[o]);
        }
      }

      if (1 === (o = arguments.length - 2)) i.children = t;else if (1 < o) {
        s = Array(o);

        for (var f = 0; f < o; f++) {
          s[f] = arguments[f + 2];
        }

        i.children = s;
      }
      return {
        $$typeof: a,
        type: e.type,
        key: l,
        ref: c,
        props: i,
        _owner: u
      };
    },
    createFactory: function createFactory(e) {
      var n = j.bind(null, e);
      return n.type = e, n;
    },
    isValidElement: P,
    version: "16.8.6",
    unstable_ConcurrentMode: p,
    unstable_Profiler: u,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
      ReactCurrentDispatcher: _,
      ReactCurrentOwner: C,
      assign: r
    }
  },
      G = {
    default: L
  },
      D = G && L || G;
  e.exports = D.default || D;
}, function (e, n, t) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      a = Object.prototype.propertyIsEnumerable;

  function i(e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var n = {}, t = 0; t < 10; t++) {
        n["_" + String.fromCharCode(t)] = t;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, n) {
    for (var t, l, c = i(e), u = 1; u < arguments.length; u++) {
      for (var s in t = Object(arguments[u])) {
        o.call(t, s) && (c[s] = t[s]);
      }

      if (r) {
        l = r(t);

        for (var f = 0; f < l.length; f++) {
          a.call(t, l[f]) && (c[l[f]] = t[l[f]]);
        }
      }
    }

    return c;
  };
}, function (e, n, t) {
  "use strict";

  var r = t(7);

  function o() {}

  function a() {}

  a.resetWarningCache = o, e.exports = function () {
    function e(e, n, t, o, a, i) {
      if (i !== r) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }

    function n() {
      return e;
    }

    e.isRequired = e;
    var t = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: n,
      element: e,
      elementType: e,
      instanceOf: n,
      node: e,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: a,
      resetWarningCache: o
    };
    return t.PropTypes = t, t;
  };
}, function (e, n, t) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      a = t(1),
      i = t.n(a);
  t(18);

  function l(e) {
    return o.a.createElement("div", null, o.a.createElement("button", {
      className: e.color
    }, e.children));
  }

  l.propType = {
    color: i.a.string
  }, n.default = l;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(1),
      o = t.n(r),
      a = t(0),
      i = t.n(a);
  t(20);

  function l(e) {
    var n = e.color,
        t = e.textColor,
        r = "".concat(e.p, "em"),
        o = "".concat(e.m, "em"),
        a = {
      padding: "".concat(r),
      margin: "".concat(o),
      color: "".concat(t),
      textColor: {
        textColor: t
      }
    };
    return i.a.createElement("div", {
      className: n,
      style: a
    }, "This is: ", n, " with textColor: ", t);
  }

  l.defaultProps = {
    color: "black",
    textColor: "white",
    p: "2em",
    m: "2.5em"
  }, l.propTypes = {
    color: o.a.string,
    textColor: o.a.string,
    p: o.a.number,
    m: o.a.number
  }, n.default = l;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      a = t(1),
      i = t.n(a);
  t(22);

  function l(e) {
    var n = e.variant,
        t = e.children;
    return "h1" === n ? o.a.createElement("h1", {
      className: "typography"
    }, t) : o.a.createElement("div", {
      className: "typography"
    }, t);
  }

  l.propTypes = {
    variant: i.a.string
  }, n.default = l;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      a = t(1),
      i = t.n(a);
  t(24);

  function l(e) {
    return o.a.createElement("div", null, o.a.createElement("label", null, e.children), o.a.createElement("input", {
      className: "input"
    }));
  }

  l.propTypes = {
    label: i.a.string
  }, n.default = l;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r);
  t(26);

  function a(e, n) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, n) {
      var t = [],
          r = !0,
          o = !1,
          a = void 0;

      try {
        for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (t.push(i.value), !n || t.length !== n); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, a = e;
      } finally {
        try {
          r || null == l.return || l.return();
        } finally {
          if (o) throw a;
        }
      }

      return t;
    }(e, n) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  n.default = function (e) {
    var n = a(Object(r.useState)(""), 2),
        t = n[0],
        i = n[1];
    return o.a.createElement("div", null, o.a.createElement("label", null, e.children), o.a.createElement("input", {
      className: "input",
      type: "text",
      name: "text",
      onChange: function onChange(e) {
        e.preventDefault(), i(e.target.value);
      },
      value: t,
      placeholder: "hook input"
    }));
  };
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      a = t(1),
      i = t.n(a);
  t(28);

  function l(e) {
    var n = e.maxWidth,
        t = e.typeName;
    return o.a.createElement("div", null, "fluid" === t ? o.a.createElement("div", {
      className: n
    }) : o.a.createElement("div", {
      style: {
        backgroundColor: "#F9690E",
        height: "100vh"
      }
    }));
  }

  l.propType = {
    typeName: i.a.string,
    maxWidth: i.a.string
  }, n.default = l;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      a = t(1),
      i = t.n(a);
  t(30);

  function l(e) {
    var n = e.nBox,
        t = e.m;
    return o.a.createElement("div", {
      className: "GridSpacing"
    }, o.a.createElement(c, {
      nBox: n,
      m: t
    }));
  }

  function c(e) {
    var n = [],
        t = e.nBox,
        r = e.m;
    console.log(t);

    for (var a = 0; a < 1; a++) {
      for (var i = [], l = 0; l < t; l++) {
        i.push(o.a.createElement("td", null, o.a.createElement("div", {
          className: "GridBox",
          style: {
            margin: "".concat(r, "rem")
          }
        }, e.children)));
      }

      n.push(o.a.createElement("tbody", null, o.a.createElement("tr", null, i)));
    }

    return n;
  }

  l.propType = {
    nBox: i.a.number,
    m: i.a.number
  }, n.default = l;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      a = t(1),
      i = t.n(a);
  t(32);

  function l() {
    return o.a.createElement("div", null, o.a.createElement(c, {
      typeGet: "nested"
    }));
  }

  function c(e) {
    return "linear" === e.typeGet ? o.a.createElement("div", {
      className: "Media"
    }, o.a.createElement("div", null, o.a.createElement("img", {
      height: 64,
      width: 64,
      src: "https://tinyurl.com/yylsuh97",
      alt: "Generic placeholder"
    })), o.a.createElement("div", null, o.a.createElement("h3", null, "Media Heading"), o.a.createElement("p", null, e.children))) : "nested" === e.typeGet ? o.a.createElement("div", null, o.a.createElement("div", {
      className: "Media"
    }, o.a.createElement("div", null, o.a.createElement("img", {
      height: 64,
      width: 64,
      src: "https://tinyurl.com/yylsuh97",
      alt: "Generic placeholder"
    })), o.a.createElement("div", null, o.a.createElement("h3", null, "Outer Paragraph"), o.a.createElement("p", null, e.children))), o.a.createElement("div", {
      style: {
        paddingLeft: "10vw"
      }
    }, o.a.createElement("div", {
      className: "Media"
    }, o.a.createElement("div", null, o.a.createElement("img", {
      height: 64,
      width: 64,
      src: "https://tinyurl.com/yylsuh97",
      alt: "Generic placeholder"
    })), o.a.createElement("div", null, o.a.createElement("h3", null, "Inner Paragraph"), o.a.createElement("p", null, e.children))))) : void console.log("Error");
  }

  l.propType = {
    typeGet: i.a.oneOf(["linear", "nested"])
  }, n.default = l;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r);
  t(34);

  function a(e) {
    return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function i(e, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function l(e) {
    return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function c(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function u(e, n) {
    return (u = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  var s = function (e) {
    function n() {
      var e, t, r;
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), t = this, (e = !(r = l(n).call(this)) || "object" !== a(r) && "function" != typeof r ? c(t) : r).state = {
        checked: !1
      }, e.onToggleSwitchChange = e.onToggleSwitchChange.bind(c(e)), e;
    }

    var t, r, s;
    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && u(e, n);
    }(n, o.a.Component), t = n, (r = [{
      key: "onToggleSwitchChange",
      value: function value() {
        this.setState({
          checked: !this.state.checked
        });
      }
    }, {
      key: "render",
      value: function value() {
        return o.a.createElement("div", {
          className: "ToggleSwitch ToggleSwitch__rounded"
        }, o.a.createElement("div", {
          className: "ToggleSwitch__wrapper"
        }, o.a.createElement("div", {
          className: "Slider ".concat(this.state.checked && "isChecked"),
          onClick: this.onToggleSwitchChange
        })));
      }
    }]) && i(t.prototype, r), s && i(t, s), n;
  }();

  n.default = s;
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      a = t(1),
      i = t.n(a);
  t(36);

  function l(e) {
    var n = e.title,
        t = e.links,
        r = e.logoImage,
        a = e.color,
        i = e.linkColor,
        l = e.logoColor,
        c = {
      backgroundColor: a
    },
        u = {
      height: "3em",
      margin: e.logoSize
    },
        s = {
      color: l
    },
        f = t.map(function (e) {
      var n = e.name,
          t = e.url;
      return o.a.createElement("li", {
        style: {
          float: "right ",
          padding: ".29em .5em .5em .5em"
        },
        className: "link"
      }, o.a.createElement("a", {
        style: {
          color: i
        },
        href: t
      }, n));
    });
    return o.a.createElement("div", {
      id: "navigation-bar"
    }, o.a.createElement("nav", {
      style: c
    }, o.a.createElement("ul", null, o.a.createElement("li", null, " ", o.a.createElement("img", {
      src: r,
      style: u,
      alt: "logoImage"
    }), o.a.createElement("a", {
      href: "#",
      id: "logo",
      style: s
    }, n)), f.reverse())));
  }

  l.propTypes = {
    title: i.a.string,
    links: i.a.arrayOf(i.a.object),
    color: i.a.string,
    linkColor: i.a.string,
    logoColor: i.a.string,
    logoImage: i.a.string,
    logoSize: i.a.string
  }, l.defaultProps = {
    title: "Zapify UI",
    links: [{
      name: "Rebooting",
      url: "https://zapify.netlify.com"
    }, {
      name: "UI With Hooks",
      url: "https://zapify.netlify.com"
    }],
    color: "#222",
    linkColor: "grey",
    logoColor: "grey",
    logoImage: "https://camo.githubusercontent.com/56702c11ebd0c8817ee8d95b1e45022b97083b8a/68747470733a2f2f692e6962622e636f2f5832334e4877362f612e706e67",
    logoSize: "-2em 0em -0.8em 0.2em"
  }, n.default = l;
}, function (e, n, t) {
  var r = t(19);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (n = e.exports = t(2)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]), n.push([e.i, '.primaryButton {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0 0.3em;\n  height: 2.4em;\n  border-radius: 5px;\n  line-height: 2.1;\n  overflow: hidden;\n  color: #fff;\n  font-size: 1.1em;\n  margin: 10px 10px 10px 10px;\n  letter-spacing: 0.01em;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  white-space: normal;\n  overflow: hidden;\n  padding: 0 1em;\n  user-select: none;\n  cursor: pointer;\n  background: linear-gradient(60deg, #1badf8, #63da38);\n  text-align: center;\n  text-decoration: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-tap-highlight-color: transparent; }\n  .primaryButton:before {\n    content: "";\n    position: absolute;\n    top: 0;\n    cursor: pointer;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: -1;\n    background-color: #63da38;\n    background-size: 100% 200%;\n    background-position: 0 100%;\n    transition: background-color 400ms; }\n  .primaryButton:after {\n    content: "";\n    position: absolute;\n    left: 50%;\n    cursor: pointer;\n    top: 50%;\n    background: #4d4dff;\n    z-index: -1;\n    width: 100%;\n    padding-top: 120%;\n    border-radius: 100%;\n    opacity: 0;\n    transform: translateX(-50%) translateY(-50%) scale(0.09);\n    transition: opacity 500ms, transform 500ms;\n    transition-delay: 0, 100ms; }\n  .primaryButton:active {\n    color: black; }\n    .primaryButton:active:after {\n      transform: translateX(-50%) translateY(-50%) scale(1.1);\n      transition: opacity 100ms, transform 100ms;\n      transition-delay: 0s;\n      opacity: 1; }\n', ""]);
}, function (e, n, t) {
  var r = t(21);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (n = e.exports = t(2)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]), n.push([e.i, ".Primary {\n  background: linear-gradient(60deg, #1badf8, #63da38);\n  color: #000000; }\n\n.Secondary {\n  background: linear-gradient(60deg, purple, pink);\n  color: #000000; }\n\n.Tertiary {\n  background: linear-gradient(60deg, #ffff00, #ffffff);\n  color: #000000; }\n\n.dark {\n  background-color: #000000;\n  color: #ffffff; }\n\n.darkPrimary {\n  background: linear-gradient(to left, #ff0000 0%, #000000 80%);\n  color: #ffffff; }\n\n.darkSecondary {\n  background: linear-gradient(to left, yellow 0%, #000000 80%);\n  color: #ffffff; }\n\n.disabled {\n  background-color: #d9d9d9;\n  color: #ffffff; }\n", ""]);
}, function (e, n, t) {
  var r = t(23);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (n = e.exports = t(2)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]), n.push([e.i, ".typography {\n  font-family: Montserrat, sans-serif;\n  color: silver; }\n", ""]);
}, function (e, n, t) {
  var r = t(25);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (n = e.exports = t(2)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]), n.push([e.i, ".input {\n  width: 95%;\n  height: 35px;\n  padding-left: 15px;\n  border: none;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  background: grey;\n  font-family: Montserrat; }\n\nlabel {\n  font-weight: 100;\n  text-align: left;\n  margin-left: 13px;\n  font-family: Montserrat;\n  text-transform: uppercase;\n  font-size: 13px;\n  padding-left: 15px;\n  padding-bottom: 2px;\n  color: #00D9FF;\n  display: block; }\n", ""]);
}, function (e, n, t) {
  var r = t(27);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (n = e.exports = t(2)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]), n.push([e.i, ".input {\n  width: 95%;\n  height: 35px;\n  padding-left: 15px;\n  border: none;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  background: grey;\n  font-family: Montserrat; }\n\nlabel {\n  font-weight: 100;\n  text-align: left;\n  margin-left: 13px;\n  font-family: Montserrat;\n  text-transform: uppercase;\n  font-size: 13px;\n  padding-left: 15px;\n  padding-bottom: 2px;\n  color: #00D9FF;\n  display: block; }\n", ""]);
}, function (e, n, t) {
  var r = t(29);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (n = e.exports = t(2)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]), n.push([e.i, ".sm {\n  background-color: linear-gradient(180deg, #1badf8 0%, #2b7de5 100%);\n  height: 20vh; }\n\n.md {\n  background-color: linear-gradient(180deg, #6c6c6c 0%, #434343 100%);\n  height: 60vh; }\n\n.xl {\n  background-color: linear-gradient(180deg, #6c6c6c 0%, #434343 100%);\n  height: 100vh; }\n", ""]);
}, function (e, n, t) {
  var r = t(31);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (n = e.exports = t(2)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]), n.push([e.i, '.GridSpacing {\n  align-items: center;\n  display: inline-block; }\n\n.GridBox {\n  border: 2px solid black;\n  width: 200px;\n  height: 250px;\n  text-align: center;\n  display: inline-block;\n  background-color: teal;\n  padding: 25px 5px;\n  -webkit-box-shadow: 5px 5px 5px 0px #000000, inset 4px 4px 15px 0px #000000, 5px 5px 15px 5px rgba(0, 0, 0, 0);\n  box-shadow: 5px 5px 5px 0px #000000, inset 4px 4px 15px 0px #000000, 5px 5px 15px 5px rgba(0, 0, 0, 0); }\n\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {\n  /* Force table to not be like tables anymore */\n  table, thead, tbody, th, td, tr {\n    display: block; }\n  /* Hide table headers (but not display: none;, for accessibility) */\n  thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px; }\n  tr {\n    margin: 0 0 5rem 0;\n    display: grid;\n    display: table-row;\n    align-content: center;\n    grid-template-columns: 1fr 1fr; }\n  td {\n    /* Behave  like a "row" */\n    border: none;\n    position: relative;\n    text-align: center;\n    padding-top: 10px; }\n  td:before {\n    /* Now like a table header */\n    position: absolute;\n    /* Top/left values mimic padding */\n    top: 0;\n    left: 6px;\n    width: 50%;\n    padding-right: 10px;\n    white-space: nowrap; } }\n', ""]);
}, function (e, n, t) {
  var r = t(33);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (n = e.exports = t(2)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]), n.push([e.i, ".Media {\n  display: flex;\n  color: #C7CE00; }\n", ""]);
}, function (e, n, t) {
  var r = t(35);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (e.exports = t(2)(!1)).push([e.i, 'html,\nbody {\n  height: 100%; }\n\nbody {\n  background: #333;\n  font-family: Helvetica Neue; }\n\n.storybook {\n  width: 100%;\n  color: #708090;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-flow: column;\n  text-align: center; }\n\n#storybook {\n  display: block; }\n\n.ToggleSwitch {\n  position: relative;\n  width: 5rem;\n  height: 2.35rem;\n  display: inline-block; }\n  .ToggleSwitch.ToggleSwitch__rounded .Slider {\n    border-radius: 15rem;\n    background: #eceff1;\n    border: 1px solid #a0a0a0; }\n    .ToggleSwitch.ToggleSwitch__rounded .Slider:before {\n      border-radius: 50%; }\n  .ToggleSwitch .ToggleSwitch__wrapper {\n    position: relative;\n    width: 5rem;\n    height: 2.35rem; }\n    .ToggleSwitch .ToggleSwitch__wrapper .Slider {\n      position: absolute;\n      cursor: pointer;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      transition: 0.4s ease; }\n      .ToggleSwitch .ToggleSwitch__wrapper .Slider:before {\n        width: 2.45rem;\n        height: 2.45rem;\n        position: absolute;\n        background: #fff;\n        content: "";\n        margin: 0;\n        padding: 0;\n        top: 50%;\n        left: 0.1rem;\n        transform: translateY(-50%);\n        transition: 0.4s;\n        cursor: pointer;\n        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23); }\n      .ToggleSwitch .ToggleSwitch__wrapper .Slider.isChecked {\n        background: #fff; }\n        .ToggleSwitch .ToggleSwitch__wrapper .Slider.isChecked:before {\n          left: calc(100% - 0.1rem - 2.45rem);\n          background: #0099ff; }\n', ""]);
}, function (e, n, t) {
  var r = t(37);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    insert: "head",
    singleton: !1
  };
  t(3)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, n, t) {
  (n = e.exports = t(2)(!1)).push([e.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]), n.push([e.i, "nav {\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  width: 100%; }\n  nav #logo {\n    font-size: 1.2em;\n    font-family: Montserrat;\n    font-weight: bold; }\n  nav ul {\n    text-align: left;\n    font-family: Montserrat;\n    list-style-type: none;\n    list-style-type: none;\n    margin: 0;\n    padding: 15px; }\n    nav ul li {\n      display: inline;\n      font-family: Montserrat;\n      font-size: 17px; }\n      nav ul li a {\n        color: #f2f2f2;\n        text-decoration: none; }\n", ""]);
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(8);
  t.d(n, "Button", function () {
    return r.default;
  });
  var o = t(9);
  t.d(n, "Box", function () {
    return o.default;
  });
  var a = t(10);
  t.d(n, "Typography", function () {
    return a.default;
  });
  var i = t(11);
  t.d(n, "TextField", function () {
    return i.default;
  });
  var l = t(12);
  t.d(n, "TextFieldHook", function () {
    return l.default;
  });
  var c = t(13);
  t.d(n, "Container", function () {
    return c.default;
  });
  var u = t(14);
  t.d(n, "Grid", function () {
    return u.default;
  });
  var s = t(15);
  t.d(n, "Media", function () {
    return s.default;
  });
  var f = t(16);
  t.d(n, "Switch", function () {
    return f.default;
  });
  var p = t(17);
  t.d(n, "ZapBar", function () {
    return p.default;
  });
}]);